import { Typography, Button, Upload } from "antd";
import React, { useState, useEffect } from "react";
import {
  RollbackOutlined,
  DownloadOutlined,
  InboxOutlined,
} from "@ant-design/icons";

import Pageloader from "../../../components/loader";
import { BASE_URL } from "../../../config/Baseurl";

import { useNavigate } from "react-router-dom";
import { swalNotification } from "../../../components/alret/notificztion";
import { validationErrors } from "../../../utils/Helpers";
import { Link } from "react-router-dom";
import { UploadProps } from "antd";

const { Title } = Typography;
const { Dragger } = Upload;

const RiderBlockBulkCSV = () => {
  const navigate = useNavigate();

  const pagename = "Rider Block Bulk";
  const [loading, setLoading] = useState(false);

  const propsNew: UploadProps = {
    name: "blockRiderCsv",
    action: BASE_URL + "api/web/rider/block-status-many",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        swalNotification(
          "Rider suspended",
          "Rider suspended successfully",
          "success"
        );
        navigate("/rider");
      } else if (info.file.status === "error") {
        if (info.fileList.length != 0) {
          swalNotification("Some error!", "Error", "error");
        }
      }
    },
  };

  return loading ? (
    <Pageloader />
  ) : (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>{pagename}</Title>
        </div>
        <div className="pch-content">
          <Button>
            <Link
              to="/files/sample-file-bulk-rider-block.csv"
              target="_blank"
              download
            >
              <DownloadOutlined /> Download Sample File
            </Link>
          </Button>
          <Button onClick={() => navigate("/rider")}>
            <RollbackOutlined />
          </Button>
        </div>
      </div>

      <Dragger {...propsNew}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag bulk rider block csv file to this area to upload
        </p>
      </Dragger>
    </div>
  );
};

export default RiderBlockBulkCSV;
